
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_yodkx_im8v7_5"
};
  